import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_GENERAL_SETTINGS_AFFILIATE_BANNER_ROUTE_NAME = Symbol('admin.settings.affiliate-banner');
export const TRANSLATION_GROUP_GENERAL_SETTINGS_AFFILIATE_BANNER = Symbol('general-settings.affiliate-banner');

export const SETTINGS_AFFILIATE_BANNER_URL = 'admin/banner_settings';

export const SETTINGS_AFFILIATE_BANNER_QUERY_KEY = 'general-settings.affiliate-banner';
export const SETTINGS_AFFILIATE_BANNER_SAVE_QUERY_KEY = 'general-settings.affiliate-banner.save';

export const ADMIN_GENERAL_SETTINGS_AFFILIATE_BANNER_PERMISSIONS = {
  BANNERSETTINGS_SHOW: new Permission(
    PermissionsList.admin.BANNERSETTINGS_SHOW,
  ),
  BANNERSETTINGS_EDIT: new Permission(
    PermissionsList.admin.BANNERSETTINGS_EDIT,
  ),
};
